import styled from "styled-components";
export const SpinnerContainerCentered = styled.div `
    margin-top: 40px;
    text-align: center;
    position: absolute;
    top: calc(50% - 25px);
    left: calc(50% - 25px);
`;
export const SpinnerContainerHorizontal = styled.div `
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    gap: 8px;
    margin: 16px 0;
`;
